import { AfterContentChecked, ChangeDetectorRef, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { IDatePickerDirectiveConfig } from 'ng2-date-picker';
import { ToastrService } from 'ngx-toastr';
import { LoaderService } from 'app/shared/services/loader.service';
import { finalize, switchMap } from 'rxjs/operators';
import * as moment from 'moment';
import { Moment } from 'moment';
import { DataTableColumn, DataTableComponent } from 'app/shared/data-table/data-table.component';
import { SortDirection } from 'app/shared/sort-direction';
import { EMPTY, Observable } from 'rxjs';
import { SearchObjectResult } from 'app/shared/search-object-result.model';
import { JsonEditorService } from 'app/shared/services/json-editor.service';
import {
  DFAsset,
  DFCarrier,
  DFCountry,
  DFCountryCarrierList
} from 'app/df-management/shared/df-management.coutry.model';
import { DFVariableCharges } from 'app/df-management/shared/df-master-data.model';
import { JsonEditorDoc } from 'app/shared/json-editor-doc.model';

import { DFManagementSearchTransFilter } from '../shared/df-management-search-filter.model';
import { DfManagementService } from '../shared/df-management.service';
import {
  BtfExportStatus,
  DFLoad,
  DFStatus,
  DFStatusCount,
  LoadStatus,
  TransactionData,
  TransactionDataAction
} from '../shared/df-transaction-data.model';
import { UploadFileTransactionDataResultList } from '../shared/upload-file-transaction-data-resultList.model';
import { DFUploadTransactionData } from '../shared/file-upload-transaction-data.model';
import { Base64ToBlob } from '../shared/utiles/base64Toblob';
import { NotificationsService } from '../shared/notifications.service';

@Component({
  selector: 'app-df-transaction-list',
  templateUrl: './df-transaction-list.component.html',
  styleUrls: ['./df-transaction-list.component.scss']
})
export class DfTransactionListComponent implements OnInit, AfterContentChecked  {

  @ViewChild('checkboxColumn', { static: true }) checkboxColumn: TemplateRef<any>;
  @ViewChild('carrierCodeColumn', { static: true }) carrierCodeColumn: TemplateRef<any>;
  @ViewChild('assetIdColumn', { static: true }) assetIdColumn: TemplateRef<any>;
  @ViewChild('loadIdColumn', { static: true }) loadIdColumn: TemplateRef<any>;
  @ViewChild('shipmentIdColumn', { static: true }) shipmentIdColumn: TemplateRef<any>;
  @ViewChild('originIdColumn', { static: true }) originIdColumn: TemplateRef<any>;
  @ViewChild('destinationIdColumn', { static: true }) destinationIdColumn: TemplateRef<any>;
  @ViewChild('pgiDateColumn', { static: true }) pgiDateColumn: TemplateRef<any>;
  @ViewChild('shippedDateColumn', { static: true }) shippedDateColumn: TemplateRef<any>;
  @ViewChild('loadedMilesColumn', { static: true }) loadedMilesColumn: TemplateRef<any>;
  @ViewChild('emptyMilesColumn', { static: true }) emptyMilesColumn: TemplateRef<any>;
  @ViewChild('btfStatusColumn', { static: true }) btfStatusColumn: TemplateRef<any>;
  @ViewChild('totalChargesColumn', { static: true }) totalChargesColumn: TemplateRef<any>;
  @ViewChild('statusColumn', { static: true }) statusColumn: TemplateRef<any>;
  @ViewChild('actionsColumn', { static: true }) actionsColumn: TemplateRef<any>;
  @ViewChild(DataTableComponent, { static : true }) transactionListTable: DataTableComponent;

  public readonly TransactionDataAction = TransactionDataAction;
  public readonly BtfExportStatus = BtfExportStatus;

  acceptedFileExtensions = ['.xlsx'];
  isVisible = false;
  isVisibleCards = false;
  pageTransData: DFStatusCount;
  editTransactionData: DFLoad;
  config: IDatePickerDirectiveConfig;
  configDate: IDatePickerDirectiveConfig;
  configDatetime: IDatePickerDirectiveConfig;
  configure: IDatePickerDirectiveConfig;
  dedicatedFleetTransactionForm: FormGroup;
  searchForm: FormGroup;
  updateChargesDataForm: FormGroup;
  searchText = '';
  countryData: DFCountryCarrierList[] = [];
  carriers: DFCountryCarrierList[] = [];
  assets: DFAsset[] = [];
  btfSubmitSuccessPopup = false;
  isPopupModel = false;
  bySubmitSuccessPopup = false;
  isPopupUpdateModel = false;
  isPopupChargesUpdatedModel = false;
  isPopupSupressCharges = false;
  loadIds: string;
  isCheckboxSelected = false;
  isErrorPopup = false;
  isPopupChargesErrorModel = false;
  isPopupCarrierChargesErrorModel = false;
  isFetchButtonDisabled = true;
  isButtonDisabled = true;
  isEditButtonDisabled = true;
  isdateSelected = false;
  isPopupDownloadModel = false;
  isPopupTransactionReportModel = false;
  isDownReportSuccessPopupModel = false;
  isFileUploadingPopupModel = false;
  isDownloadErrorReport = false;
  isReportDownloaded = false;
  issuccessReportDownloaded = false;
  isTransactionInProgress = false;
  dateAndTimeForm: FormGroup;
  selectedItems: TransactionData[] = [];
  statusList: DFStatus[] = [] ;
  selectedCharges: TransactionData[] = [];
  carrierCodeList: DFCountryCarrierList[] = [];
  countOfRecordsInExcel: string;
  countOfRecordsInCMA: string;
  countOfErrorRecords: string;
  pgiDate: DataTableColumn;
  p = 1;
  pSize = 10;
  countryCode: string;
  statusCode: string;
  status: string;
  isVisibleCharges = false;
  isDisabledRentCharge = true;
  failureResultList: UploadFileTransactionDataResultList[] = [];
  successResultList: UploadFileTransactionDataResultList[] = [];
  blob = new Base64ToBlob;
  dateErrorMsg = false;
  filteredStatusList: any[];
  isPopupVisible!: Observable<boolean>;
  selectedCheckboxes: Set<string> = new Set();
  shipmentIds: string[] = [];
  shipments: string[] = [];
  columns: DataTableColumn[] = [];
  sortColumn: DataTableColumn;
  SortDirection = SortDirection.DESC;
  buttonValues: TransactionDataAction;
  failedReport: string;
  uploadChargesResult: DFUploadTransactionData;
  fixedFrequencyCharge: string;
  filters: DFManagementSearchTransFilter = {
    carrierCodeList: null,
    carrierCode: null,
    assetId: null,
    loadIds: null,
    statusCode: null,
    entryEndDate: null,
    entryStartDate: null,
    search: null,
  };

  loadPage: (...config) => Observable<SearchObjectResult<TransactionData>> = null;
  selectCountry: string;
  selectCarrierID: string;
  selectAssetID: string;
  selectStatus: string;

  canSendMilageDataForSelectedCharges: boolean = true;

  constructor(private fb: FormBuilder,
    private dfManagementService: DfManagementService,
    private toastr: ToastrService,
    private loader: LoaderService,
    private jsonEditorService: JsonEditorService,
    private translate: TranslateService,
    private changeDetector: ChangeDetectorRef,
    private notificationService: NotificationsService
  ) {}

  ngOnInit(): void {
    this.dedicatedFleetTransactionForm = this.fb.group({
      truckRentCharges: ['', [Validators.required]],
      amount: this.fb.array([]),
      totalManualAmount: [''],
      loadedMiles: ['', [Validators.required]],
      emptyMiles: ['', [Validators.required]],
      remarks: [''],
    });
    this.searchForm = this.fb.group({
      assetId: [null],
      carrierId: [null],
      country: [null],
      loadId: [''],
      startDate: ['', [Validators.required]],
      endDate: [],
      status: [null]
    });
    this.dateAndTimeForm = this.fb.group({
      fromDate: [''],
      toDate: [''],
      selectCarriers: ['']
    });
    this.updateChargesDataForm = this.fb.group({
      totalCharges: ['', [Validators.required]],
      updatedTotalChargesNote: ['', [Validators.required]],
    });
    this.config = {
      appendTo: 'body',
      drops: 'down',
      firstDayOfWeek: 'mo',
      format: 'YYYY-MM-DD',
      isDayDisabledCallback: (date: Moment) => {
        return (date.diff(moment().utc().format('YYYY-MM-DD'), 'days') > 0);
      },
      max: null,
      min: null,
      disableKeypress: false,
      unSelectOnClick: true,
    }
    this.configDate = {
      appendTo: 'body',
      drops: 'down',
      firstDayOfWeek: 'mo',
      format: 'YYYY-MM-DD',
      max: null,
      min: null,
      disableKeypress: false,
      unSelectOnClick: true,
    }

    this.configDatetime = {
      appendTo: 'body',
      drops: 'down',
      firstDayOfWeek: 'mo',
      format: 'YYYY-MM-DD',
      isDayDisabledCallback: (date: Moment) => {
        return (date.diff(moment().utc().format('YYYY-MM-DD'), 'days') > 0);
      },
      max: null,
      min: null,
      disableKeypress: false,
      unSelectOnClick: true,
    }
    this.configure = {
      appendTo: 'body',
      drops: 'down',
      firstDayOfWeek: 'mo',
      format: 'YYYY-MM-DD',
      max: null,
      min: null,
      disableKeypress: false,
      unSelectOnClick: true,
    }
    this.getDFCountryResponse();
    this.displayColumns();
    this.isPopupVisible = this.notificationService.isPopupVisible;
  }

  displayColumns() {
    if (this.countryCode === 'USA') {
      const carrierCode = {
        name: 'carrierCode',
          displayed: true,
          translationKey: 'df-management.df-transaction.form.table-headings.carier-id',
          template: this.carrierCodeColumn,
          sortable: true,
          alignCenter: true,
      };
      this.columns = [
        {
          name: 'checkboxItem',
          displayed: true,
          translationKey: '',
          template: this.checkboxColumn,
          sortable: false,
          alignCenter: true,
        },
        carrierCode,
        {
          name: 'loadId',
          displayed: true,
          translationKey: 'df-management.df-transaction.form.table-headings.load-id',
          template: this.loadIdColumn,
          sortable: false,
          alignCenter: true,
        }, {
          name: 'shipmentId',
          displayed: true,
          translationKey: 'df-management.df-transaction.form.table-headings.shipment-id',
          template: this.shipmentIdColumn,
          sortable: false,
          alignRight: false,
          alignCenter: true,
        }, {
          name: 'originId',
          displayed: true,
          translationKey: 'df-management.df-transaction.form.table-headings.location-id',
          template: this.originIdColumn,
          sortable: false,
          alignCenter: true,
        }, {
          name: 'destinationId',
          displayed: true,
          translationKey: 'df-management.df-transaction.form.table-headings.des-location-id',
          template: this.destinationIdColumn,
          sortable: false,
          alignCenter: true,
        }, {
          name: 'actualPickupDate',
          displayed: true,
          translationKey: 'df-management.df-transaction.form.table-headings.shipped-date',
          template: this.shippedDateColumn,
          sortable: false,
          alignCenter: true,
        }, {
          name: 'truckRent',
          displayed: true,
          translationKey: 'df-management.df-transaction.form.table-headings.truck-rent',
          template: this.totalChargesColumn,
          sortable: false,
          alignCenter: true,
        }, {
          name: 'loadedMiles',
          displayed: true,
          translationKey: 'df-management.df-transaction.form.table-headings.loaded-miles',
          template: this.loadedMilesColumn,
          sortable: false,
          alignCenter: true,
        }, {
          name: 'emptyMiles',
          displayed: true,
          translationKey: 'df-management.df-transaction.form.table-headings.empty-miles',
          template: this.emptyMilesColumn,
          sortable: false,
          alignCenter: true,
        }, {
          name: 'btfStatus',
          displayed: true,
          translationKey: 'df-management.df-transaction.form.table-headings.btf-status',
          template: this.btfStatusColumn,
          sortable: false,
          alignCenter: true,
        }, {
          name: 'loadStatusShortform',
          displayed: true,
          translationKey: 'df-management.df-transaction.form.table-headings.status',
          template: this.statusColumn,
          sortable: false,
          alignCenter: true,
        }, {
          name: 'actions',
          displayed: true,
          translationKey: 'df-management.table.actions',
          template: this.actionsColumn,
          sortable: false,
          alignCenter: true,
        },
      ];
      this.sortColumn = carrierCode;
    } else {
      const assetId = {
        name: 'assetId',
        displayed: true,
        translationKey: 'df-management.df-transaction.form.table-headings.assest-id',
        template: this.assetIdColumn,
        sortable: true,
        alignCenter: true,
      };
      this.columns = [
        {
          name: 'checkboxItem',
          displayed: true,
          translationKey: '',
          template: this.checkboxColumn,
          sortable: false,
          alignCenter: true,
        },
        {
          name: 'carrierCode',
          displayed: true,
          translationKey: 'df-management.df-transaction.form.table-headings.carier-id',
          template: this.carrierCodeColumn,
          sortable: false,
          alignCenter: true,
        },
        assetId,
        {
          name: 'loadId',
          displayed: true,
          translationKey: 'df-management.df-transaction.form.table-headings.load-id',
          template: this.loadIdColumn,
          sortable: false,
          alignCenter: true,
        },
        {
          name: 'shipmentId',
          displayed: true,
          translationKey: 'df-management.df-transaction.form.table-headings.shipment-id',
          template: this.shipmentIdColumn,
          sortable: false,
          alignRight: false,
          alignCenter: true,
        }, {
          name: 'originId',
          displayed: true,
          translationKey: 'df-management.df-transaction.form.table-headings.location-id',
          template: this.originIdColumn,
          sortable: false,
          alignCenter: true,
        },
        {
          name: 'destinationId',
          displayed: true,
          translationKey: 'df-management.df-transaction.form.table-headings.des-location-id',
          template: this.destinationIdColumn,
          sortable: false,
          alignCenter: true,
        },
        {
          name: 'pgiDate',
          displayed: true,
          translationKey: 'df-management.df-transaction.form.table-headings.pgi-date',
          template: this.pgiDateColumn,
          sortable: false,
          alignCenter: true,
        },
        {
          name: 'totalCharges',
          displayed: true,
          translationKey: 'df-management.df-transaction.form.table-headings.total-charge',
          template: this.totalChargesColumn,
          sortable: false,
          alignCenter: true,
        }, {
          name: 'loadStatusShortform',
          displayed: true,
          translationKey: 'df-management.df-transaction.form.table-headings.status',
          template: this.statusColumn,
          sortable: false,
          alignCenter: true,
        },
        {
          name: 'actions',
          displayed: true,
          translationKey: 'df-management.table.actions',
          template: this.actionsColumn,
          sortable: false,
          alignCenter: true,
        },
      ];
      this.sortColumn = assetId;
    }
  }

  setExistingHeaders(chargesList: DFVariableCharges[]): FormArray {
    const formArray = new FormArray([]);
    chargesList?.forEach((s, i) => {
      formArray.push(
        this.fb.group({
          id: new FormControl(s.id),
          charge_code: new FormControl(s.charge_code),
          charge_amount: new FormControl(s.charge_amount),
          charge_type: new FormControl(s.charge_type)
        })
      );
    });
    return formArray;
  }

  resetAllSearchData() {
    this.searchForm.controls['carrierId'].reset();
    this.searchForm.controls['loadId'].reset();
    this.searchForm.controls['assetId'].reset();
    this.searchForm.controls['startDate'].reset();
    this.searchForm.controls['endDate'].reset();
    this.searchForm.controls['status'].reset();
    this.searchText = '';
    this.filters.assetId = null;
    this.filters.statusCode = null;
    this.filters.loadIds = null;
    this.filters.carrierCode = null;
    this.filters.entryEndDate = null;
    this.filters.entryStartDate = null;
    this.filters.carrierCodeList = null;
  }

  resetSearchData() {
    if (this.countryCode) {
    this.searchForm.controls['carrierId'].reset();
    this.searchForm.controls['loadId'].reset();
    this.searchForm.controls['assetId'].reset();
    this.searchForm.controls['startDate'].reset();
    this.searchForm.controls['endDate'].reset();
    this.searchForm.controls['status'].reset();
    this.searchText = '';
    this.filters.assetId = null;
    this.filters.statusCode = null;
    this.filters.loadIds = null;
    this.filters.carrierCode = null;
    this.filters.entryEndDate = null;
    this.filters.entryStartDate = null;
    this.filters.carrierCodeList = null;
    this.assets = [];
    this.applySearch('fleetManagement')
    }
  }

  onEditClick(editdata: DFLoad) {
    this.editTransactionData = editdata;
    this.dedicatedFleetTransactionForm.controls['truckRentCharges'].patchValue(editdata?.rentCharges);
    this.dedicatedFleetTransactionForm.controls['totalManualAmount'].patchValue(editdata?.totalCharges);
    this.dedicatedFleetTransactionForm.controls['remarks'].patchValue(editdata?.updatedTotalChargesNote);
    this.dedicatedFleetTransactionForm.controls['emptyMiles'].patchValue(editdata?.emptyMiles);
    this.dedicatedFleetTransactionForm.controls['loadedMiles'].patchValue(editdata?.loadedMiles);
    if (editdata.loadStatus === 'Manual charges calculated') {
      this.dedicatedFleetTransactionForm.controls['truckRentCharges'].clearValidators();
      this.isDisabledRentCharge = true;
    } else {
      this.dedicatedFleetTransactionForm.controls['truckRentCharges'].setValidators(Validators.required);
      this.isDisabledRentCharge = false;
    }
    if (editdata.loadingCharges?.length) {
      this.dedicatedFleetTransactionForm.setControl(
        'amount',
        this.setExistingHeaders(editdata.loadingCharges)
      );
    }
    this.isVisible = true;
  }

  onCloseClick() {
    this.isVisible = false;
    this.resetDfTransactionData();
  }

  resetDfTransactionData() {
    this.dedicatedFleetTransactionForm.controls['truckRentCharges'].reset();
    this.dedicatedFleetTransactionForm.controls['emptyMiles'].reset();
    this.dedicatedFleetTransactionForm.controls['loadedMiles'].reset();
  }

  updateStatus(statusValue: DFStatus) {
    if (statusValue != null) {
      this.filters.statusCode = statusValue.id
    } else {
      this.filters.statusCode = null;
    }
  }

  getAllStatus() {
    this.dfManagementService.getAllStatus()
      .pipe(finalize(() => this.loader.stopLoad()))
      .subscribe((status: DFStatus[]) => {
        this.statusList = status;
        this.filteredStatusList = status.filter(s => s.statusShortForm !== 'NC');
      }, (error: HttpErrorResponse) => {
        this.toastr.error(error['error_message'] || this.translate.instant('df-management.table.error-fetching-status'));
      });
  }

  getDFCountryResponse() {
    this.loader.startLoad();
    this.dfManagementService.getAllcountry()
      .pipe(finalize(() => this.loader.stopLoad()))
      .subscribe(country => {
        this.getAllStatus();
        this.translatePlaceholders();
        this.countryData = country.results;
        this.countryData.sort((a, b) => (a.countryCode > b.countryCode) ? 1 : -1)
      }, (error: HttpErrorResponse) => {
        this.translatePlaceholders();
        this.toastr.error(error['error_message'] || this.translate.instant('df-management.table.error-fetching-country')
        );
      });
  }

  updateCountry(country: DFCountry) {
    this.loader.startLoad();
    this.resetAllSearchData();
    this.selectedCharges = [];
    if (country != null) {
      this.countryCode = country?.countryCode;
      if (this.countryCode === 'USA') {
        this.displayColumns();
        // Don't judge, we don't have the budget to make it cleaner
        this.dedicatedFleetTransactionForm.get('loadedMiles')?.setValidators([Validators.required]);
        this.dedicatedFleetTransactionForm.get('emptyMiles')?.setValidators([Validators.required]);
      } else {
        this.displayColumns();
        this.dedicatedFleetTransactionForm.get('loadedMiles')?.clearValidators();
        this.dedicatedFleetTransactionForm.get('emptyMiles')?.clearValidators();
      }
      this.dfManagementService.getAllCarrierIdBasedOnCountry(country?.countryCode)
        .pipe(finalize(() => this.loader.stopLoad()))
        .subscribe(carriers => {
          this.fixedFrequencyCharge = carriers['results'].fixed_charge_frequency;
          this.isFetchButtonDisabled = false;
          this.isButtonDisabled = true
          this.isEditButtonDisabled = true;
          if (carriers['status_code'] === '1') {
            if (carriers['results']['carrier'] === null) {
              this.carriers = [];
              this.assets = [];
              this.toastr.error(this.translate.instant('df-management.table.no-carriers-found'));
            } else {
            this.carriers = carriers['results']['carrier'];
            this.carriers.sort((a, b) => (a.carrier > b.carrier) ? 1 : -1)
            this.assets = [];
            this.selectAllForDropdownItems(this.carriers);
            }
          }
          if (carriers['error_code'] === '-10') {
            this.carriers = [];
            this.assets = [];
            const tempFilters = this.filters
            delete tempFilters['carrierCodeList'];
            this.filters = tempFilters
            this.toastr.error(carriers['error_message']);
          }
        }, (error: HttpErrorResponse) => {
          this.toastr.error(error['error_message'] || this.translate.instant('df-management.table.error-fetching-carriers'));
        })
    } else {
      this.filters.carrierCode = null;
      this.countryCode = null;
      this.carriers = [];
      this.assets = [];
      this.isFetchButtonDisabled = true;
      this.isEditButtonDisabled = true;
      this.isButtonDisabled = true;
      this.loader.stopLoad();
      this.searchForm.controls['country'].reset();
      this.displayColumns();
      this.filters.carrierCodeList = null;
    }
  }

  updateCarrierId(carrier: DFCarrier[]) {
    this.filters.assetId = null;
    if (carrier != null) {
      const carrierList = [];
      const assetList = [];
      carrier.forEach(carriers => {
      carrierList.push(carriers.carrier_code);
      carriers.asset.filter(assets => {
        assetList.push(assets);
      });
      })
      this.filters.carrierCodeList = carrierList?.join(',');
      this.assets = assetList;
      this.assets.sort((a, b) => (a.asset_id > b.asset_id) ? 1 : -1)
      this.searchForm.controls['assetId'].reset();
    } else {
      this.filters.carrierCodeList = null;
      this.filters.assetId = null;
      this.assets = [];
      this.searchForm.controls['assetId'].reset();
    }
  }

  updateAsset(asset: DFAsset) {
    if (asset != null) {
      this.filters.assetId = asset?.asset_id;
    } else {
      this.filters.assetId = null;
    }
  }

  applySearch(loads: string) {
    this.isFetchButtonDisabled = true;
    this.isEditButtonDisabled = true;
    this.isVisibleCards = true;
    this.isButtonDisabled = true;
    if (this.searchForm.value.loadId != null) {
      const loadIdsArray = this.searchForm.value.loadId.split(/[\s,;]+/);
      const filteredLoadIdsArray = loadIdsArray.filter(id => id.trim() !== '');
      if (filteredLoadIdsArray.length > 0) {
        this.filters.loadIds = filteredLoadIdsArray;
      } else {
        delete this.filters.loadIds;
      }
    } else {
      delete this.filters.loadIds;
    }

    this.filters.entryStartDate = this.searchForm.value.startDate;
    this.filters.entryEndDate = this.searchForm.value.endDate;
    this.filters.search = this.searchText;
    const tempFilters = this.filters
    if (tempFilters.carrierCodeList == null) {
      delete tempFilters['carrierCodeList'];
    }

    this.loadPage = (...config): any => {
      this.loader.startLoad();
      const mConfig = {
        page: config[0] - 1,
        pageSize: config[1],
        sortColumn: config[2],
        direction: config[3],
        countryCode: this.countryCode,
        filters: tempFilters
      };
      this.loader.stopLoad();
      this.displayStatusCountList(...config);
      return this.dfManagementService.searchAllTransactionLoads(mConfig, loads);
    }
  }

  getTransactionData() {
    this.isFetchButtonDisabled = false;
    this.isEditButtonDisabled = false;
    this.isButtonDisabled = false;
  }

  resetUpdatedCharges() {
    this.updateChargesDataForm.controls['totalCharges'].reset();
    this.updateChargesDataForm.controls['updatedTotalChargesNote'].reset();
  }

  resetDateAndTimeForm() {
    this.dateAndTimeForm.controls['fromDate'].reset();
    this.dateAndTimeForm.controls['toDate'].reset();
    this.dateAndTimeForm.controls['selectCarriers'].reset();
    this.filters.carrierCodeList = null;
  }

  cancelCharges() {
    this.resetUpdatedCharges();
    this.isVisibleCharges = false;
  }

  updateCharge() {
    if ((this.isCheckboxSelected) || (!this.isCheckboxSelected && this.selectedCharges?.length !== 0)) {
      this.isVisibleCharges = !this.isVisibleCharges
    } else if (this.isCheckboxSelected === false && (this.selectedCharges?.length === 0)) {
      this.isErrorPopup = true;
      this.isVisibleCharges  = false;
    }
  }

  onCloseEvent() {
    this.isVisibleCharges = false;
    this.resetUpdatedCharges();
  }

  showConfirmationPopup() {
    this.isPopupUpdateModel = true;
    this.isVisibleCharges = false;
  }

  bulkBtfSubmit() {
    this.loader.startLoad();
    const loadIds = this.selectedCharges.map(item => item.loadId);
    this.dfManagementService.bulkBtfSubmit(this.countryCode, loadIds)
        .pipe(finalize(() => this.loader.stopLoad()))
        .subscribe(_ => {
          this.toastr.success(this.translate.instant('df-management.form.file.file-upload-success-message'));
          this.selectedCheckboxes.clear();
          this.selectedCharges = [];
          this.btfSubmitSuccessPopup = true;
        }, (error: HttpErrorResponse) => {
          this.toastr.error(error.error.message || this.translate.instant(
            'df-management.form.file.file-upload-error-message'));
        });
  }

  submitManualCharges() {
    this.loader.startLoad();
    const loadList = []
    let countryCode, carrierCode, assetId, loadIds;
    this.selectedCharges.forEach(item => {
      countryCode = item.countryCode
      carrierCode = item.carrierCode;
      assetId = item.assetId;
      loadList.push(item.loadId)
      loadIds = loadList?.join(',');
    })
      let body ;
      body = {
        total_charges: this.updateChargesDataForm.value.totalCharges,
        updated_total_charges_note: this.updateChargesDataForm.value.updatedTotalChargesNote

      }
      this.dfManagementService.updateBulkUploadCharges(countryCode, carrierCode, assetId, loadIds, body)
      .pipe(finalize(() => this.loader.stopLoad()))
      .subscribe((succeed: TransactionData) => {
        if (succeed['error'] === true) {
          this.toastr.error(succeed['data']['messages'][0]);
          this.applySearch('fleetManagement');
          this.selectedCheckboxes.clear();
          this.selectedCharges = [];
        } else {
          this.isPopupChargesUpdatedModel = true;
          this.toastr.success(succeed['data']);
        }
        this.resetUpdatedCharges();
      }, (error: HttpErrorResponse) => {
        this.toastr.error(error.error.message || this.translate.instant('df-management.table.error-post-data'));
      });
  }

  submitSupressChargeData() {
    this.loader.startLoad();
    const countryCode = this.countryCode;
    const loadId = this.editTransactionData.loadId;
    this.dfManagementService.updateSupressCharges(countryCode, loadId)
      .pipe(finalize(() => this.loader.stopLoad()))
      .subscribe(
        (response: any) => {
          if (response['error'] === true) {
            this.toastr.error(response['data']['messages'][0]);
            this.applySearch('fleetManagement');
          } else {
            this.isPopupSupressCharges = true;
            this.isVisible = false;
            this.toastr.success(response['data']);
          }
        },
        (error: HttpErrorResponse) => {
          this.toastr.error(error.error.message || this.translate.instant('df-management.table.error-post-data'));
        }
      );
  }

  supressConfirm() {
    this.isPopupSupressCharges = false;
    this.applySearch('fleetManagement');
  }

  isSuppressChargeDisabled(): boolean {
    const status = this.editTransactionData.loadStatusShortform;
    return status === LoadStatus.X ||
           status === LoadStatus.MC ||
           status === LoadStatus.F ||
           status === LoadStatus.UL ||
           status === LoadStatus.S ||
           status === LoadStatus.NC ||
           status === LoadStatus.NE;
  }

  public isSubmitToBYDisabled(): boolean {
    return !this.isStatusCompatibleWithBYSubmission(this.editTransactionData.loadStatusShortform) ||
           !this.dedicatedFleetTransactionForm.valid;
  }

  private isStatusCompatibleWithBYSubmission(status: string): boolean {
    return status !== LoadStatus.S &&
           status !== LoadStatus.UL &&
           status !== LoadStatus.X
  }

  private isStatusCompatibleWithBTFSubmission(status: string): boolean {
    return status !== LoadStatus.UL && status !== LoadStatus.X
  }

  confirmErrorData() {
    this.isErrorPopup = false;
  }

  checkCheckboxSelection() {
    const uniqueCarrierIds = new Set(this.selectedCharges.map(item => item.carrierCode));
    const uniqueAssetIds = new Set(this.selectedCharges.map(item => item.assetId));

    if (uniqueCarrierIds.size > 1 || uniqueAssetIds.size > 1) {
      this.isPopupChargesErrorModel = true;
      this.isPopupCarrierChargesErrorModel = true;
    }
  }

  onCheckboxChange(checked: any, value: any) {
    this.isCheckboxSelected = checked;
    if (this.selectedCheckboxes.has(value)) {
      value.selected = false;
      this.selectedCheckboxes.delete(value);
      this.selectedCharges.forEach((item: any, index: number)  => {
        if (item['id'] === value['id']) {
          this.selectedCharges.splice(index, 1);
        }
      })
    } else {
      if (this.selectedCharges?.length === 0) {
        this.selectedCheckboxes.add(value);
        value.selected = true;
        this.selectedCharges.push(value);
      } else if (this.selectedCharges?.length > 0) {
        this.selectedCheckboxes.add(value);
        if (this.countryCode !== 'USA') {
          this.selectedCharges.forEach((element: any) => {
            if (element.assetId === value['assetId']) {
              value.selected = true;
              this.selectedCharges.push(value);
              this.selectedCharges = Array.from(new Set(this.selectedCharges));
            } else {
              this.isPopupChargesErrorModel = true;
            }
          });
        } else {
          this.selectedCharges.forEach((element: any) => {
            if (element.carrierCode === value['carrierCode']) {
              value.selected = true;
              this.selectedCharges.push(value);
              this.selectedCharges = Array.from(new Set(this.selectedCharges));
            } else {
              this.isPopupCarrierChargesErrorModel = true;
            }
          });
        }
      }
    }

    this.canSendMilageDataForSelectedCharges = !this.selectedCharges
      .find(item => this.transactionDataIsIncompatibleWithBTFSubmission(item))

    return this.selectedCharges;
  }

  private transactionDataIsIncompatibleWithBTFSubmission(transactionData: TransactionData) {
    return !this.isStatusCompatibleWithBYSubmission(transactionData.loadStatusShortform) ||
      transactionData.btfStatus !== BtfExportStatus.PENDING;
  }


  confirmSameChargesError() {
    this.isPopupChargesErrorModel =  false;
  }

  confirmSameCarrierChargesError() {
    this.isPopupCarrierChargesErrorModel = false;
  }

  displayStatusCountList(...config) {
    this.loader.startLoad();
    const mConfig = {
      page: config[0] - 1,
      pageSize: config[1],
      sortColumn: config[2],
      direction: config[3],
      countryCode:  this.countryCode,
      filters: this.filters
    };
    this.dfManagementService.getStatusCount(mConfig)
    .pipe(finalize(() => this.loader.stopLoad()))
    .subscribe((responce: DFStatusCount) => {
      this.pageTransData = responce;
    }, (error: HttpErrorResponse) => {
      this.pageTransData = null;
      this.toastr.error(error['error_message'] || this.translate.instant('data-table.errors.load-page'));
    })
  }

  filterNoOfLoads() {
    if (this.countryCode) {
      const statusObj = this.statusList.find(status => status.statusShortForm === null);
      this.searchForm.controls['status'].patchValue(statusObj);
      this.updateStatus(statusObj);
      this.applySearch('fleetManagement');
    }
  }

  filterAutomaticCharges() {
    if (this.countryCode) {
    const statusObj = this.statusList.find(status => status.statusShortForm === 'AC');
    this.searchForm.controls['status'].patchValue(statusObj);
    this.updateStatus(statusObj);
    this.applySearch('fleetManagement');
    }
  }

  filterCreatedData() {
    if (this.countryCode) {
    const statusObj = this.statusList.find(status => status.statusShortForm === 'C');
    this.searchForm.controls['status'].patchValue(statusObj);
    this.updateStatus(statusObj);
    this.applySearch('fleetManagement');
    }
  }

  filterSuccessData() {
    if (this.countryCode) {
    const statusObj = this.statusList.find(status => status.statusShortForm === 'S');
    this.searchForm.controls['status'].patchValue(statusObj);
    this.updateStatus(statusObj);
    this.applySearch('fleetManagement');
    }
  }

  filterManualCharges() {
    if (this.countryCode) {
    const statusObj = this.statusList.find(status => status.statusShortForm === 'MC');
    this.searchForm.controls['status'].patchValue(statusObj);
    this.updateStatus(statusObj);
    this.applySearch('fleetManagement');
    }
  }

  filterFailureData() {
    if (this.countryCode) {
    const statusObj = this.statusList.find(status => status.statusShortForm === 'F');
    this.searchForm.controls['status'].patchValue(statusObj);
    this.updateStatus(statusObj);
    this.applySearch('fleetManagement');
    }
  }

  filterNoContractData() {
    if (this.countryCode) {
    const statusObj = this.statusList.find(status => status.statusShortForm === 'NC');
    this.searchForm.controls['status'].patchValue(statusObj);
    this.updateStatus(statusObj);
    this.applySearch('fleetManagement');
    }
  }

  filterNotEligibleData() {
    if (this.countryCode) {
    const statusObj = this.statusList.find(status => status.statusShortForm === 'NE');
    this.searchForm.controls['status'].patchValue(statusObj);
    this.updateStatus(statusObj);
    this.applySearch('fleetManagement');
    }
  }

  cancelData() {
    this.isPopupModel = false;
  }

  cancelUpdateData() {
    this.isPopupUpdateModel = false;
  }

  dateConfirmation() {
    this.isdateSelected = false;
  }

  selectDateScreen() {
    this.isdateSelected = true;
    this.dateAndTimeForm.controls['toDate'].valueChanges.subscribe(res => {
      if (moment(res).utc().isBefore(moment(this.dateAndTimeForm.value.fromDate).utc())) {
        this.dateErrorMsg = true;
      } else {
        this.dateErrorMsg = false;
      }
    })
  }

  onCloseIcon() {
    this.resetDateAndTimeForm()
    this.isdateSelected = false;
  }

  onCloseReport() {
    this.isReportDownloaded = false;
  }

  onCloseSucessReport() {
    this.issuccessReportDownloaded = false;
  }

  saveTransactionData(event: TransactionDataAction) {
    this.buttonValues = event;
    this.isPopupModel = true;
    this.isVisible = false;
  }

  confirmData() {
    this.updateTransactionData();
  }

  confirmUpdateData() {
    this.isPopupUpdateModel = false;
    this.submitManualCharges();
  }

  downloadTransactionData() {
    this.loader.startLoad();
    this.dfManagementService.downloadTransactionDataUploadTemplate(this.countryCode).subscribe(
      (data: Blob) => {
        this.triggerFileDownload(data, this.countryCode + '-upload-charges-template.xlsx');
        this.isPopupDownloadModel = true;
      },
      error => {
        console.error('Error downloading file:', error);
      }
    );
  }

  triggerFileDownload(data: Blob, fileName: string): void {
    const blob = new Blob([data], { type: 'text/plain' });
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    this.loader.stopLoad();
  }

  triggerFilesDownload(data: Blob, fileName: string): void {
    const blob = new Blob([data], { type: 'application/octet-stream' });
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    this.loader.stopLoad();
  }

  downloadAllTransactionReport() {
    this.loader.startLoad();
    const timestamp = this.getFormattedTimestamp();
    const fileName = `${this.countryCode}-Transaction Report-${timestamp}.xlsx`;
    const statusControl = this.searchForm.controls['status'];
    const statusCode = statusControl ? statusControl.value : undefined;

    const tempFilters = { ...this.filters };
    if (!tempFilters.carrierCodeList) {
        delete tempFilters['carrierCodeList'];
    }

    this.dfManagementService.downloadAllTransactions(this.countryCode, statusCode, tempFilters)
        .subscribe(
            (data: Blob) => {
                this.triggerFilesDownload(data, fileName);
                this.isPopupTransactionReportModel = true;
                this.loader.stopLoad();
            },
            error => {
                console.error('Error downloading file:', error);
                this.loader.stopLoad();
            }
        );
  }

  getFormattedTimestamp(): string {
    const now = new Date();
    const year = now.getFullYear();
    const month = this.padNumber(now.getMonth() + 1);
    const day = this.padNumber(now.getDate());
    const hours = this.padNumber(now.getHours());
    const minutes = this.padNumber(now.getMinutes());
    const seconds = this.padNumber(now.getSeconds());
    return `${year}-${month}-${day}_${hours}-${minutes}-${seconds}`;
  }

  padNumber(num: number): string {
    return num < 10 ? '0' + num : num.toString();
  }

  confirmDownloadReportButton() {
    this.isDownReportSuccessPopupModel = false;
  }

  downloadFailureReport() {
    this.loader.startLoad();
    this.dfManagementService.downloadFailureTransactionData(this.countryCode).
    subscribe(
      (data: Blob) => {
        this.triggerFileDownload(data, this.countryCode + '-failed-loads.xlsx');
        this.isDownReportSuccessPopupModel = true;
      },
      error => {
        this.loader.stopLoad();
        console.error('Error downloading file:', error);
      }
    );
  }

  confirmChargesData() {
    this.isPopupChargesUpdatedModel = false;
    this.applySearch('fleetManagement');
    this.selectedCharges = [];
    this.isCheckboxSelected = false;
  }

  submitTransactionData(event: TransactionDataAction) {
    this.buttonValues = event;
    this.updateTransactionData();
  }

  submitConfirm() {
    this.bySubmitSuccessPopup = false;
    this.btfSubmitSuccessPopup = false;
    this.applySearch('fleetManagement');
  }

  translatePlaceholders() {
    this.selectCountry = this.translate.instant('df-management.filters.placeholder.select-country');
    this.selectCarrierID = this.translate.instant('df-management.filters.placeholder.select-carrierId');
    this.selectAssetID = this.translate.instant('df-management.filters.placeholder.select-asset-id');
    this.selectStatus = this.translate.instant('df-management.filters.placeholder.select-status');
  }

  submitToBTF(): void {
    this.loader.startLoad();
    this.isTransactionInProgress = true;
    this.buttonValues = null;
    this.dfManagementService.addLoadingCharge(this.getUpdatedTransactionData())
      .pipe(
        switchMap(success => {
          if (success['error_code'] === '-10') {
            this.toastr.error(success['error_message']);
            return EMPTY;
          }
          return this.dfManagementService.uploadTransactionToBTF(this.countryCode, [success.results.load_id]);
        }),
        finalize(() => this.loader.stopLoad())
      ).subscribe(_ => {
        this.toastr.success(this.translate.instant('df-management.form.file.file-upload-success-message'));
        this.isVisible = false;
        this.isTransactionInProgress = false;
        this.btfSubmitSuccessPopup = true;
      }, (e: HttpErrorResponse) => {
        console.error(e);
        this.toastr.error(e.error.message || this.translate.instant('df-management.form.file.default'));
        this.isTransactionInProgress = false;
      });
  }

  public canSubmitToBTF(): boolean {
    return (this.isStatusCompatibleWithBTFSubmission(this.editTransactionData.loadStatusShortform)
        && this.dedicatedFleetTransactionForm.valid)
      && this.editTransactionData.btfStatus !== BtfExportStatus.DONE
  }

  public disabledSaveTransactionData(): boolean {
    if (this.countryCode !== 'USA') {
      return this.editTransactionData.loadStatusShortform === 'S'
        || this.disabledSaveCommonTransactionData();
    }
    return this.disabledSaveCommonTransactionData()
      || (this.dedicatedFleetTransactionForm.get('totalManualAmount') == null
        && this.dedicatedFleetTransactionForm.get('loadedMiles') == null
        && this.dedicatedFleetTransactionForm.get('emptyMiles') == null)
      || (this.editTransactionData.loadStatusShortform === 'S'
        && this.editTransactionData.btfStatus === BtfExportStatus.DONE);
  }

  private disabledSaveCommonTransactionData(): boolean {
    return this.editTransactionData.loadStatusShortform === 'UL'
      || !this.dedicatedFleetTransactionForm.valid;
  }

  private updateTransactionData(): void {
      this.loader.startLoad();
      this.isTransactionInProgress = true;
      const body = this.getUpdatedTransactionData();

      if (this.buttonValues === TransactionDataAction.SAVE) {
        this.dfManagementService.addLoadingCharge(body)
            .pipe(finalize(() => this.loader.stopLoad()))
            .subscribe((succeed: TransactionData) => {
              if (succeed['error_code'] === '-10') {
                this.toastr.error(succeed['error_message']);
              }
              this.applySearch('fleetManagement');
              this.resetDfTransactionData();
              this.isPopupModel = false;
              this.isTransactionInProgress = false;
            }, error => {
              const errorMessage = error.error.message
                || this.translate.instant('df-management.table.error-post-transaction-data');
              this.toastr.error(errorMessage);
              this.isTransactionInProgress = false;
              return EMPTY;
            });
      } else if (this.buttonValues === TransactionDataAction.SUBMIT) {
        this.dfManagementService.addLoadingCharge(body)
            .pipe(finalize(() => this.loader.stopLoad()))
            .subscribe((succeed: TransactionData) => {
              if (succeed.hasOwnProperty('error_code') && succeed['error_code'] === '-10') {
                this.toastr.error(succeed['error_message']);
                this.isVisible = false;
              } else {
                this.isVisible = false;
                this.bySubmitSuccessPopup = true;
              }
              this.isTransactionInProgress = false;
            }, error => {
              const errorMessage = error.error.message
                || this.translate.instant('df-management.table.error-post-transaction-data');
              this.toastr.error(errorMessage);
              this.isTransactionInProgress = false;
              return EMPTY;
            });
      } else {
        this.isTransactionInProgress = false;
        throw new Error('Missing Action, cannot add loading charge');
      }
  }

  private getUpdatedTransactionData(): TransactionData {
    const formArray = this.dedicatedFleetTransactionForm.controls[
      'amount'
      ] as FormArray;
    const chargesFormArray = formArray.getRawValue();
    const truckRentCharge = this.dedicatedFleetTransactionForm.value.truckRentCharges;
    const truckTotalCharge = this.dedicatedFleetTransactionForm.value.totalManualAmount;
    const emptyMiles = this.dedicatedFleetTransactionForm.value.emptyMiles;
    const loadedMiles = this.dedicatedFleetTransactionForm.value.loadedMiles;
    const remarksCharges = this.dedicatedFleetTransactionForm.value.remarks;

    const updatedTransactionData = new TransactionData();
    updatedTransactionData.id = this.editTransactionData['id'];
    updatedTransactionData.action = this.buttonValues;
    updatedTransactionData.countryCode = this.editTransactionData['countryCode'];
    updatedTransactionData.carrierCode = this.editTransactionData['carrierCode'];
    updatedTransactionData.assetId = this.editTransactionData['assetId'];
    updatedTransactionData.assetType = this.editTransactionData['assetType'];
    updatedTransactionData.status = this.editTransactionData['status'];
    updatedTransactionData.loadId = this.editTransactionData['loadId'];
    updatedTransactionData.deliveryId = this.editTransactionData['deliveryId'];
    updatedTransactionData.voucherId = this.editTransactionData['voucherId'];
    updatedTransactionData.actualPickupDate = this.editTransactionData['actualPickupDate'];
    updatedTransactionData.loadStartDate = this.editTransactionData['loadStartDate'];
    updatedTransactionData.loadEndDate = this.editTransactionData['loadEndDate'];
    updatedTransactionData.pieces = this.editTransactionData['pieces'];
    updatedTransactionData.podDate = this.editTransactionData['podDate'];
    updatedTransactionData.pgiDate = this.editTransactionData['pgiDate'];
    updatedTransactionData.podStatus = this.editTransactionData['podStatus'];
    updatedTransactionData.originId = this.editTransactionData['originId'];
    updatedTransactionData.destinationId = this.editTransactionData['destinationId'];
    updatedTransactionData.distanceTravel = this.editTransactionData['distanceTravel'];
    updatedTransactionData.distanceUnit = this.editTransactionData['distanceUnit'];
    updatedTransactionData.chargeType = this.editTransactionData['chargeType'];
    updatedTransactionData.extraDistanceCharges = this.editTransactionData['extraDistanceCharges'];
    updatedTransactionData.serviceId = this.editTransactionData['serviceId'];
    updatedTransactionData.currency = this.editTransactionData['currency'];
    updatedTransactionData.createdBy = this.editTransactionData['createdBy'];
    updatedTransactionData.updatedBy = this.editTransactionData['updatedBy'];
    updatedTransactionData.createdDate = this.editTransactionData['createdDate'];
    updatedTransactionData.updatedDate = this.editTransactionData['updatedDate'];
    updatedTransactionData.rentCharges = truckRentCharge ? truckRentCharge : this.editTransactionData['rentCharges'];
    updatedTransactionData.loadingCharges = this.editTransactionData['loadingCharges'] && !this.editTransactionData['loadingCharges']?.length ? this.editTransactionData['loadingCharges'] : chargesFormArray;
    updatedTransactionData.charges = this.editTransactionData['charges'];
    updatedTransactionData.totalCharges = truckTotalCharge ? truckTotalCharge : this.editTransactionData['totalCharges'];
    updatedTransactionData.emptyMiles = emptyMiles ? emptyMiles : this.editTransactionData['emptyMiles'];
    updatedTransactionData.loadedMiles = loadedMiles ? loadedMiles : this.editTransactionData['loadedMiles'];
    updatedTransactionData.updatedTotalChargesNote = remarksCharges ? remarksCharges : this.editTransactionData['updatedTotalChargesNote'];

    return updatedTransactionData;
  }

  openJsonInEditor(payload: string) {
    this.loader.startLoad();
    this.jsonEditorService.createJsonEditorDoc(this.translate.instant(`df-management.table.event-data`), JSON.stringify(payload))
      .pipe(finalize(() => this.loader.stopLoad()))
      .subscribe((result: JsonEditorDoc) => {
        if (result.ok) {
          window.open(`http://jsoneditoronline.org/?id=${result.id}`, '_blank');
        }
      });
  }

  /** select all drop down values based on select all check box in carrier Id dropdown */
  selectAllForDropdownItems(items: any[]) {
    // tslint:disable-next-line:no-shadowed-variable
    const allSelect = items => {
      items.forEach(element => {
        element['selectedAllGroup'] = 'selectedAllGroup';
      });
    };
    allSelect(items);
  }

  confirmDownload() {
    this.isPopupDownloadModel = false;
  }

  confirmReportDownload() {
    this.isPopupTransactionReportModel = false;
  }

  uploadTransactionDataFile(csvFile: File) {
    const shippedStartDate  = this.dateAndTimeForm.value.fromDate;
    const shippedEndDate = this.dateAndTimeForm.value.toDate;
    const carrierList = [];
    const carrierCodeList = this.dateAndTimeForm.value.selectCarriers.map(carrier => carrier.carrier_code).join(',');

    this.loader.startLoad();
    this.openFileUploadingPopup();
    this.dfManagementService.uploadAllTransactionData(csvFile, this.countryCode, shippedStartDate, shippedEndDate, carrierCodeList)
        .pipe(finalize(() => {
          this.closeFileUploadingPopup();
          this.loader.stopLoad();
        }))
        .subscribe(result => {
          this.uploadChargesResult = result;
          this.failedReport = result.failedImportReportByteStream;
          if (result.status === 'FAILED') {
            this.failureResultList = result.resultList;
            if (result.reason === 'FAILED') {
              this.toastr.error(this.translate.instant('df-management.form.file.file-upload-error-message'));
            } else if (result.reason === 'INVALID HEADER COLUMNS') {
              this.toastr.error(this.translate.instant('df-management.form.file.file-upload-error-wrong-structure'));
            } else {
              this.toastr.error(result.reason);
            }
            this.isdateSelected = false;
            this.isReportDownloaded = true;
            this.countOfRecordsInExcel = result.countOfRecordsInExcel;
            this.countOfRecordsInCMA = result.countOfRecordsInCMA;
            this.countOfErrorRecords = result.countOfErrorRecords;
          } else {
            this.successResultList = result.resultList;
            this.toastr.success(this.translate.instant('df-management.form.file.file-upload-success-message'));
            this.isdateSelected = false;
            this.issuccessReportDownloaded = true;
            this.countOfRecordsInExcel = result.countOfRecordsInExcel;
          }
          this.resetDateAndTimeForm();
        }, (e: HttpErrorResponse) => {
          console.error(e);
          this.toastr.error(e.error.message || this.translate.instant('df-management.form.file.default'));
        });
  }

  downloadFailedReport () {
    if (this.uploadChargesResult.reason !== 'FAILED') {
      const blob = this.blob.base64ToBlob(this.failedReport, 'application/octet-stream');
      const a = document.createElement('a');
      document.body.appendChild(a);
      const url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = String(this.countryCode + '-success-upload-charges-report.xlsx');
      a.click();
      window.URL.revokeObjectURL(url);
      a.remove();
    } else {
      const blob = this.blob.base64ToBlob(this.failedReport, 'application/octet-stream');
      const a = document.createElement('a');
      document.body.appendChild(a);
      const url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = String(this.countryCode + '-failed-upload-charges-report.xlsx');
      a.click();
      window.URL.revokeObjectURL(url);
      a.remove();
    }
  }

  downloadErrorPopup() {
    this.isReportDownloaded = false;
    this.downloadFailedReport();
    this.isDownloadErrorReport = true;
  }

  downloadSuccessPopup() {
    this.issuccessReportDownloaded = false;
    this.downloadFailedReport();
    this.isDownloadErrorReport = true;
  }

  confirmDownloadPopup() {
    this.isDownloadErrorReport = false;
  }

  openFileUploadingPopup() {
    this.isdateSelected = false;
    this.isFileUploadingPopupModel = true;
  }

  closeFileUploadingPopup() {
    this.isFileUploadingPopupModel = false;
  }

  getShipmentsString(deliveryId: string) {
    this.shipmentIds = deliveryId?.split(', ')
    return this.shipmentIds?.join(', ');
  }

  shouldDisplayIcon(deliveryId: string): boolean {
    this.shipmentIds = deliveryId?.split(', ');
    return this.shipmentIds?.length > 1;
  }

  getSingleDeliveryId(deliveryId: string): string {
    this.shipmentIds = deliveryId?.split(', ');
    return this.shipmentIds[0];
  }

  ngAfterContentChecked() {
    this.changeDetector.detectChanges();
  }

  isSingleDeliveryId(): boolean {
    return this.editTransactionData?.deliveryId && this.editTransactionData.deliveryId?.length === 1;
  }

  isMultipleDeliveryIds(): boolean {
    return this.editTransactionData?.deliveryId && this.editTransactionData.deliveryId?.length > 1;
  }

  formatDeliveryIds(): string {
    if (this.isSingleDeliveryId()) {
        return this.editTransactionData.deliveryId[0] || '-';
    } else if (this.isMultipleDeliveryIds()) {
        return this.editTransactionData.deliveryId?.split(', ')?.join(' ') || '-';
    } else {
        return '-';
    }
  }

  openPopup(): void {
    this.notificationService.open();
  }
}
